import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationSection from './ConfirmationSection';

// Era/campaign and confinement dates have their own pages, which render
// through the default confirmation fields.
const ConfirmationPrisonerOfWar = ({ formData }) => {
  const { powStatus } = formData || {};
  if (typeof powStatus !== 'boolean') return null;

  return (
    <ConfirmationSection
      title="Prisoner of war (POW)"
      rows={[
        {
          label: 'Have you ever been a prisoner of war?',
          value: powStatus ? 'Yes' : 'No',
        },
      ]}
    />
  );
};

ConfirmationPrisonerOfWar.propTypes = {
  formData: PropTypes.shape({
    powStatus: PropTypes.bool,
  }),
};

export default ConfirmationPrisonerOfWar;
